<template>
  <div class="bloco margem agenda-lista-dia-root">
    <div class="agenda-cal-filtros">
      <div class="agenda-cal-filtro">
        <label class="agenda-cal-filtro-label" for="filtro-setor-lista-dia">Área ou setor a ser visitado</label>
        <BuscaAutocomplete
          input-id="filtro-setor-lista-dia"
          v-model="filtroSetorNome"
          :options="setoresLista"
          value-key="nome"
          :label-fn="rotuloSetorSelect"
          :style-fn="estiloOptionSetor"
          input-class="agenda-cal-filtro-input"
          empty-label="Todos"
          placeholder="Buscar setor…"
          :loading="setoresCarregando"
          loading-label="Carregando setores…"
          :disabled="setoresCarregando"
        />
      </div>
      <div class="agenda-cal-filtro agenda-cal-filtro--pesquisa-visitante">
        <label class="agenda-cal-filtro-label" for="filtro-visitante-lista-dia">Pesquisar visitante</label>
        <div class="agenda-cal-pesquisa-row">
          <input id="filtro-visitante-lista-dia" v-model.trim="filtroNomeVisitanteCal" type="search"
            class="agenda-cal-filtro-input agenda-cal-filtro-input--com-botao"
            placeholder="Nome ou documento (CPF/RG)" autocomplete="off" :disabled="pesquisandoVisitanteEnter"
            @keydown.enter.prevent="executarPesquisaVisitanteEnter" />
          <button type="button" class="agenda-cal-btn-pesquisar" :disabled="pesquisandoVisitanteEnter"
            aria-label="Pesquisar visitante (agenda do dia ou cadastro)" title="Mesma ação do app: Enter ou clique"
            @click="executarPesquisaVisitanteEnter">
            <i v-if="pesquisandoVisitanteEnter" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
            <i v-else class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="agenda-cal-filtro">
        <label class="agenda-cal-filtro-label" for="filtro-anfitriao-lista-dia">Nome do anfitrião</label>
        <BuscaAutocomplete
          input-id="filtro-anfitriao-lista-dia"
          v-model="filtroNomeAnfitriaoCal"
          :options="anfitriaoOpcoesAutocomplete"
          :label-fn="nomeExibicaoAnfitriao"
          :meta-fn="metaAnfitriaoAutocomplete"
          input-class="agenda-cal-filtro-input"
          empty-label="Todos"
          placeholder="Buscar colaborador…"
          :loading="colaboradoresAnfitriaoCarregando"
          loading-label="Carregando colaboradores…"
          :disabled="colaboradoresAnfitriaoCarregando"
        />
      </div>
      <button type="button" class="agenda-cal-limpar-filtros" @click="limparFiltros">Limpar filtros</button>
    </div>
    <div class="bloco margem agenda-container">
      <div v-if="visitasDoDiaFiltradas.length > 0" class="agenda-header">
        <div class="agenda-resumo">
          <span class="resumo-item">{{ visitasDoDiaFiltradas.length }} visita(s)</span>
          <span class="resumo-item">{{ aguardandoCheckin }} aguardando check-in</span>
          <span class="resumo-item">{{ emVisita }} em visita</span>
          <span class="resumo-item">{{ concluidas }} concluída(s)</span>
        </div>
      </div>
      <div v-if="!carregando && visitasDoDiaFiltradas.length > 0" class="agenda-follow-lista">
        <div v-for="v in visitasOrdenadas" :key="v.agendaItemKey || v.id + '-' + (v.visitanteIndex ?? 0)"
          class="agenda-follow-card agenda-follow-card--clicavel" :class="classeLinha(v)" role="button" tabindex="0"
          :aria-label="'Abrir dados completos da visita: ' + textoVisitante(v)" @click="abrirDadosCompletosVisita(v.id)"
          @keydown.enter.prevent="abrirDadosCompletosVisita(v.id)"
          @keydown.space.prevent="abrirDadosCompletosVisita(v.id)">
          <div class="follow-card-topo linha alinha-v">
            <div class="follow-card-identificacao">
              <div class="follow-horario-bloco">
                <span class="follow-hora-principal">{{ formatarHorario(v.horarioEntrada) }}</span>
                <span v-if="v.horarioSaida" class="follow-hora-secundaria">saída {{ formatarHorario(v.horarioSaida)
                  }}</span>
              </div>
              <div class="follow-dados-visita">
                <div class="agenda-card-nome">{{ textoVisitante(v) }}</div>
                <div class="agenda-card-empresa">{{ v.empresa }}</div>
                <div v-if="v.areaSetorVisitado" class="agenda-card-setor fonte-menor">{{ v.areaSetorVisitado }}</div>
              </div>
            </div>
            <div class="follow-card-acoes linha alinha-v">
              <span class="chip" :class="classeBadgeStatus(v.status, v.cancelada)">{{ textoStatus(v.status, v.cancelada)
              }}</span>
              <button type="button" class="acao-secundaria btn-checklist" :title="tituloBotaoChecklist(v)"
                @click.stop="abrirChecklist(v.id, v.visitanteIndex)">
                <i :class="iconeBotaoChecklist(v)"></i> {{ textoBotaoChecklist(v) }} </button>
            </div>
          </div>
          <div v-if="v.cancelada" class="follow-cancelada-msg fonte-menor"> Visita cancelada — acompanhamento
            interrompido. </div>
          <div v-else class="follow-trilha" role="list" aria-label="Etapas da visita">
            <template v-for="(etapa, idx) in etapasFollowUp" :key="etapa.valor">
              <div class="follow-ponto-wrap" role="listitem">
                <div class="follow-ponto" :class="classeEtapaFollowUp(v, etapa.valor)">
                  <span class="follow-ponto-icone" aria-hidden="true">
                    <i v-if="etapaConcluida(v, etapa.valor)" class="fa-solid fa-check"></i>
                    <span v-else class="follow-ponto-num">{{ idx + 1 }}</span>
                  </span>
                </div>
                <span class="follow-ponto-rotulo fonte-menor" :title="etapa.label">{{ etapa.labelCurto }}</span>
              </div>
              <div v-if="idx < etapasFollowUp.length - 1" class="follow-ligacao"
                :class="classeLigacaoFollowUp(v, etapa.valor)" aria-hidden="true" />
            </template>
          </div>
        </div>
      </div>
      <div v-if="!carregando && visitasDoDiaFiltradas.length === 0" class="mensagem-vazia alinha-centro"> Nenhuma visita
        agendada para esta data. </div>
      <div v-if="carregando" class="agenda-loading alinha-centro">
        <i class="fas fa-spinner fa-spin"></i> Carregando agenda...
      </div>
    </div>
    <div v-if="modalEscolhaAgendaBusca" class="modal-overlay" role="dialog" aria-modal="true"
      aria-labelledby="modal-busca-agenda-lista-titulo">
      <div class="modal-backdrop" @click="modalEscolhaAgendaBusca = false"></div>
      <div class="modal-sheet modal-sheet--lista-escolha">
        <h3 id="modal-busca-agenda-lista-titulo" class="modal-titulo-busca">Escolha a visita</h3>
        <p class="modal-sub-busca fonte-menor fonte-fraca">Várias visitas combinam com a pesquisa neste dia.</p>
        <ul class="modal-lista-busca">
          <li v-for="item in opcoesAgendaPesquisaBusca"
            :key="item.agendaItemKey || item.id + '-' + (item.visitanteIndex ?? 0)" class="modal-item-busca"
            @click="selecionarAgendaBuscaItem(item)">
            <i class="fa-regular fa-calendar-check modal-item-icone-busca"></i>
            <div class="modal-item-textos-busca">
              <span class="modal-item-nome-busca">{{ textoVisitante(item) }}</span>
              <span class="modal-item-meta-busca">{{ metaLinhaAgendaBusca(item) }}</span>
            </div>
            <i class="fa-solid fa-chevron-right modal-item-seta-busca"></i>
          </li>
        </ul>
        <button type="button" class="modal-fechar-busca" @click="modalEscolhaAgendaBusca = false">Fechar</button>
      </div>
    </div>
    <div v-if="modalEscolhaCadastroBusca" class="modal-overlay" role="dialog" aria-modal="true"
      aria-labelledby="modal-busca-cad-lista-titulo">
      <div class="modal-backdrop" @click="modalEscolhaCadastroBusca = false"></div>
      <div class="modal-sheet modal-sheet--lista-escolha">
        <h3 id="modal-busca-cad-lista-titulo" class="modal-titulo-busca">Escolha o visitante</h3>
        <p class="modal-sub-busca fonte-menor fonte-fraca">Vários cadastros encontrados — selecione para nova visita.
        </p>
        <ul class="modal-lista-busca">
          <li v-for="v in opcoesCadastroPesquisaBusca" :key="'cad-busca-lista-' + v.id" class="modal-item-busca"
            @click="selecionarCadastroBuscaItem(v)">
            <i class="fa-regular fa-user modal-item-icone-busca"></i>
            <div class="modal-item-textos-busca">
              <span class="modal-item-nome-busca">{{ v.nomeCompleto }}</span>
              <span class="modal-item-meta-busca">{{ metaLinhaCadastroBuscaItem(v) }}</span>
            </div>
            <i class="fa-solid fa-chevron-right modal-item-seta-busca"></i>
          </li>
        </ul>
        <button type="button" class="modal-fechar-busca" @click="modalEscolhaCadastroBusca = false">Fechar</button>
      </div>
    </div>
  </div>
</template>
<script>
import { createToaster } from "@meforma/vue-toaster";
import solicitacaoVisitaService from "@/services/solicitacao-visita-service";
import setorService from "@/services/setor-service";
import { listarSugestoesAnfitriao, nomeExibicaoAnfitriao } from "@/services/anfitriao-service";
import { rotuloSetorSelect, estiloOptionSetor } from "@/utils/setor-hierarquia";
import visitanteService from "@/services/visitante-service";
import BuscaAutocomplete from "@/components/BuscaAutocomplete/BuscaAutocomplete.vue";
import { linhaDocumentosVisitante } from "@/config/visitante-documentos";
import { gravarPrefillVisitanteNovaVisita } from "@/utils/acesso-prefill-visitante";
import { itemCorrespondePesquisaVisitanteMobile } from "@/utils/agenda-busca-visitante";
import { textoStatus as textoStatusConfig } from "@/config/status-visita";

const toaster = createToaster({ position: "top-right" });

const ETAPAS_FOLLOW_UP = [
  { valor: 1, label: "Solicitação", labelCurto: "Solic." },
  { valor: 4, label: "Check-in", labelCurto: "Check-in" },
  { valor: 5, label: "Acompanhamento", labelCurto: "Acomp." },
  { valor: 6, label: "Check-out", labelCurto: "Check-out" },
];

export default {
  name: "AgendaListaVisitasDia",

  components: { BuscaAutocomplete },

  props: {
    dataSelecionada: { type: String, required: true },
    /** Valor de `query.from` ao abrir dados completos (ex.: checkin-dia). */
    origemDadosCompletos: { type: String, default: "checkin-dia" },
  },

  data() {
    return {
      visitasDoDia: [],
      carregando: false,
      etapasFollowUp: ETAPAS_FOLLOW_UP,
      filtroSetorNome: "",
      filtroNomeVisitanteCal: "",
      filtroNomeAnfitriaoCal: "",
      setoresLista: [],
      setoresCarregando: false,
      /** Sugestões de anfitrião (`GET usuario/acesso/anfitrioes`). */
      colaboradoresAnfitriaoLista: [],
      colaboradoresAnfitriaoCarregando: false,
      modalEscolhaAgendaBusca: false,
      opcoesAgendaPesquisaBusca: [],
      modalEscolhaCadastroBusca: false,
      opcoesCadastroPesquisaBusca: [],
      pesquisandoVisitanteEnter: false,
    };
  },

  computed: {
    /** Colaboradores da API + anfitriões que aparecem no dia mas não estão na lista. */
    anfitriaoOpcoesAutocomplete() {
      const fromApi = Array.isArray(this.colaboradoresAnfitriaoLista) ? [...this.colaboradoresAnfitriaoLista] : [];
      const seen = new Set(
        fromApi.map((x) => nomeExibicaoAnfitriao(x).trim().toLowerCase()).filter(Boolean)
      );
      const extras = [];
      for (const v of this.visitasDoDia || []) {
        const n = String(v.nomeAnfitriao || "").trim();
        if (!n) continue;
        const k = n.toLowerCase();
        if (seen.has(k)) continue;
        seen.add(k);
        extras.push({
          id: 0,
          usuario_nome: n,
          nome_completo: n,
          setor_nome: null,
        });
      }
      extras.sort((a, b) => nomeExibicaoAnfitriao(a).localeCompare(nomeExibicaoAnfitriao(b), "pt-BR"));
      return [...fromApi, ...extras];
    },
    visitasDoDiaSemFiltroVisitante() {
      let list = Array.isArray(this.visitasDoDia) ? [...this.visitasDoDia] : [];
      const setor = String(this.filtroSetorNome || "").trim();
      const fa = String(this.filtroNomeAnfitriaoCal || "").trim().toLowerCase();
      if (setor) {
        list = list.filter((v) => String(v.areaSetorVisitado || "").trim() === setor);
      }
      if (fa) {
        list = list.filter((v) => String(v.nomeAnfitriao || "").trim().toLowerCase() === fa);
      }
      return list;
    },
    visitasParaBuscaEnter() {
      return this.visitasDoDiaSemFiltroVisitante.filter((v) => !v.cancelada);
    },
    visitasDoDiaFiltradas() {
      let list = Array.isArray(this.visitasDoDia) ? [...this.visitasDoDia] : [];
      const setor = String(this.filtroSetorNome || "").trim();
      const fvRaw = String(this.filtroNomeVisitanteCal || "").trim();
      const fa = String(this.filtroNomeAnfitriaoCal || "").trim().toLowerCase();
      if (setor) {
        list = list.filter((v) => String(v.areaSetorVisitado || "").trim() === setor);
      }
      if (fvRaw) {
        list = list.filter((v) => this.itemCombinaComPesquisa(v, fvRaw));
      }
      if (fa) {
        list = list.filter((v) => String(v.nomeAnfitriao || "").trim().toLowerCase() === fa);
      }
      return list;
    },
    statusPainel() {
      return (s) => (s >= 6 ? 6 : s >= 5 ? 5 : s >= 4 ? 4 : 1);
    },
    visitasOrdenadas() {
      const chave = (v) => {
        const h = v.horarioEntrada;
        if (!h) return "99:99";
        const s = String(h).trim().slice(0, 5);
        const parts = s.split(":");
        if (parts.length < 2) return s;
        const hh = String(parseInt(parts[0], 10) || 0).padStart(2, "0");
        const mm = String(parseInt(parts[1], 10) || 0).padStart(2, "0");
        return `${hh}:${mm}`;
      };
      return [...this.visitasDoDiaFiltradas].sort((a, b) => chave(a).localeCompare(chave(b)));
    },
    aguardandoCheckin() {
      return this.visitasDoDiaFiltradas.filter((v) => this.statusPainel(v.status ?? 1) === 4).length;
    },
    emVisita() {
      return this.visitasDoDiaFiltradas.filter((v) => this.statusPainel(v.status ?? 1) === 5).length;
    },
    concluidas() {
      return this.visitasDoDiaFiltradas.filter((v) => this.statusPainel(v.status ?? 1) === 6).length;
    },
  },

  watch: {
    dataSelecionada: {
      immediate: true,
      handler() {
        this.carregarAgenda();
      },
    },
  },

  created() {
    this.carregarSetoresAgenda();
    this.carregarColaboradoresAnfitriaoSelect();
  },

  methods: {
    rotuloSetorSelect,
    estiloOptionSetor,
    nomeExibicaoAnfitriao,

    metaAnfitriaoAutocomplete(item) {
      const s = item?.setor_nome?.trim();
      return s ? `Setor: ${s}` : "";
    },

    async carregarSetoresAgenda() {
      this.setoresCarregando = true;
      try {
        this.setoresLista = await setorService.obterListaEstruturaHierarquica();
      } catch (e) {
        console.error(e);
        this.setoresLista = [];
      } finally {
        this.setoresCarregando = false;
      }
    },

    async carregarColaboradoresAnfitriaoSelect() {
      this.colaboradoresAnfitriaoCarregando = true;
      try {
        this.colaboradoresAnfitriaoLista = await listarSugestoesAnfitriao();
      } catch (e) {
        console.error(e);
        this.colaboradoresAnfitriaoLista = [];
        toaster.show("Não foi possível carregar a lista de colaboradores para o filtro.", { type: "warning" });
      } finally {
        this.colaboradoresAnfitriaoCarregando = false;
      }
    },
    limparFiltros() {
      this.filtroSetorNome = "";
      this.filtroNomeVisitanteCal = "";
      this.filtroNomeAnfitriaoCal = "";
    },
    apenasDigitos(s) {
      return String(s || "").replace(/\D/g, "");
    },
    itemCombinaComPesquisa(v, termoBruto) {
      const t = String(termoBruto || "").trim().toLowerCase();
      if (!t) return false;
      const nome = String(v.nome || "").toLowerCase();
      if (nome.includes(t)) return true;
      const docItem = this.apenasDigitos(v.documentoVisitante);
      const docBusca = this.apenasDigitos(t);
      if (docBusca.length >= 3 && docItem.includes(docBusca)) return true;
      return false;
    },
    textoVisitante(v) {
      return v.nome || "—";
    },
    formatarHorario(h) {
      if (!h) return "—";
      const s = String(h).trim();
      if (s.length >= 4 && s.length <= 5) return s.slice(0, 5);
      return s || "—";
    },
    textoStatus(s, cancelada) {
      return textoStatusConfig(s, cancelada);
    },
    classeBadgeStatus(s, cancelada) {
      if (cancelada) return "status-cancelada";
      if (s >= 6) return "bg-sucesso";
      if (s >= 5) return "bg-ok";
      if (s >= 4) return "bg-alerta";
      return "status-agendada";
    },
    classeLinha(v) {
      if (v.cancelada) return "linha-cancelada";
      if (v.status >= 6) return "linha-concluida";
      if (v.status >= 5) return "linha-em-visita";
      if (v.status >= 4) return "linha-aguardando";
      return "";
    },
    etapaConcluida(v, valorEtapa) {
      if (v.cancelada) return false;
      const s = this.statusPainel(v.status ?? 1);
      if (valorEtapa < 6) return s > valorEtapa;
      return s >= 6;
    },
    classeEtapaFollowUp(v, valorEtapa) {
      if (v.cancelada) return "etapa-neutra";
      if (this.etapaConcluida(v, valorEtapa)) return "etapa-feita";
      if (this.statusPainel(v.status ?? 1) === valorEtapa) return "etapa-atual";
      return "etapa-pendente";
    },
    classeLigacaoFollowUp(v, valorEtapa) {
      if (v.cancelada) return "ligacao-neutra";
      const s = this.statusPainel(v.status ?? 1);
      return s > valorEtapa ? "ligacao-feita" : "ligacao-pendente";
    },
    textoBotaoChecklist(v) {
      if (v.status >= 6) return "Check-out realizado";
      if (v.status >= 5) return "Registrar saída";
      return "Registrar entrada";
    },
    tituloBotaoChecklist(v) {
      if (v.status >= 6) return "Ver check list (visita finalizada)";
      if (v.status >= 5) return "Abrir para registrar saída do visitante";
      return "Abrir para registrar entrada do visitante";
    },
    iconeBotaoChecklist(v) {
      if (v.status >= 6) return "fa-solid fa-circle-check";
      if (v.status >= 5) return "fa-solid fa-right-from-bracket";
      return "fa-solid fa-right-to-bracket";
    },
    abrirChecklist(id, visitanteIndex) {
      if (!id) return;
      const vi = visitanteIndex != null ? Number(visitanteIndex) : 0;
      const q = Number.isFinite(vi) && vi > 0 ? { vi: String(vi) } : {};
      this.$router.push({ path: "/acesso/checklist/" + id, query: q });
    },

    metaLinhaAgendaBusca(item) {
      const h = this.formatarHorario(item.horarioEntrada);
      const emp = String(item.empresa || "").trim();
      const parts = [];
      if (h && h !== "—") parts.push(`Entrada ${h}`);
      if (emp) parts.push(emp);
      return parts.length ? parts.join(" · ") : "—";
    },

    metaLinhaCadastroBuscaItem(v) {
      const docs = linhaDocumentosVisitante(v);
      const mail = String(v.email || "").trim();
      if (docs !== "Sem documento") return `${docs}${mail ? ` · ${mail}` : ""}`;
      return mail || "—";
    },

    irNovaVisitaComData() {
      const data = String(this.dataSelecionada || "").slice(0, 10);
      const q = /^\d{4}-\d{2}-\d{2}$/.test(data) ? { data } : {};
      this.$router.push({ path: "/solicitacao-visita/novo", query: q });
    },

    selecionarAgendaBuscaItem(item) {
      this.modalEscolhaAgendaBusca = false;
      this.abrirChecklist(item.id, item.visitanteIndex);
    },

    selecionarCadastroBuscaItem(v) {
      this.modalEscolhaCadastroBusca = false;
      gravarPrefillVisitanteNovaVisita({
        nomeCompleto: v.nomeCompleto,
        cpf: v.cpf || v.CPF || "",
        rg: v.rg || v.documentoRgCnh || "",
        documentoRgCnh: v.rg || v.documentoRgCnh || "",
        email: v.email,
        telefoneWhatsapp: v.telefoneWhatsapp,
        visitanteId: v.id > 0 ? v.id : null,
      });
      this.irNovaVisitaComData();
    },

    async executarPesquisaVisitanteEnter() {
      const t = String(this.filtroNomeVisitanteCal || "").trim();
      if (t.length < 2) {
        toaster.show("Digite pelo menos 2 caracteres (nome ou documento).", { type: "warning" });
        return;
      }
      const naAgenda = this.visitasParaBuscaEnter.filter((v) => itemCorrespondePesquisaVisitanteMobile(v, t));
      if (naAgenda.length === 1) {
        this.abrirChecklist(naAgenda[0].id, naAgenda[0].visitanteIndex);
        return;
      }
      if (naAgenda.length > 1) {
        this.opcoesAgendaPesquisaBusca = naAgenda;
        this.modalEscolhaAgendaBusca = true;
        return;
      }
      this.pesquisandoVisitanteEnter = true;
      try {
        const encontrados = await visitanteService.buscarPorNome(t);
        if (encontrados.length === 0) {
          this.irNovaVisitaComData();
          return;
        }
        if (encontrados.length === 1) {
          const v = encontrados[0];
          gravarPrefillVisitanteNovaVisita({
            nomeCompleto: v.nomeCompleto,
            cpf: v.cpf || v.CPF || "",
            rg: v.rg || v.documentoRgCnh || "",
            documentoRgCnh: v.rg || v.documentoRgCnh || "",
            email: v.email,
            telefoneWhatsapp: v.telefoneWhatsapp,
            visitanteId: v.id > 0 ? v.id : null,
          });
          this.irNovaVisitaComData();
          return;
        }
        this.opcoesCadastroPesquisaBusca = encontrados;
        this.modalEscolhaCadastroBusca = true;
      } catch (err) {
        console.error(err);
        toaster.show(err?.response?.data?.message || "Não foi possível pesquisar o visitante.", { type: "error" });
      } finally {
        this.pesquisandoVisitanteEnter = false;
      }
    },
    abrirDadosCompletosVisita(id) {
      if (!id) return;
      const query = { from: this.origemDadosCompletos };
      if (this.origemDadosCompletos === "checkin-dia" && this.dataSelecionada) {
        query.data = this.dataSelecionada;
      }
      this.$router.push({
        name: "DadosCompletosVisita",
        params: { id: String(id) },
        query,
      });
    },
    async carregarAgenda() {
      const ymd = String(this.dataSelecionada || "").slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return;
      this.carregando = true;
      this.visitasDoDia = [];
      try {
        const lista = await solicitacaoVisitaService.listarAgendaDoDia(ymd);
        this.visitasDoDia = Array.isArray(lista) ? lista : [];
      } catch (err) {
        console.error(err);
        toaster.show("Erro ao carregar agenda do dia.", { type: "error" });
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>
<style scoped>
.agenda-lista-dia-root {
  padding: 1.1rem 1.15rem 1.25rem;
  background: var(--cor-bg);
  border: 1px solid var(--cor-separador);
  border-radius: 12px;
}

.agenda-cal-filtros {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  margin-bottom: 1.1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--cor-separador);
}

.agenda-cal-filtro {
  flex: 1 1 11rem;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.agenda-cal-filtro-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--cor-fonte-fraca);
}

.agenda-cal-filtro-select,
.agenda-cal-filtro-input {
  width: 100%;
  padding: 0.45rem 0.55rem;
  border: 1px solid var(--cor-separador);
  border-radius: 8px;
  font-size: 0.88rem;
  background: var(--cor-bg);
  color: var(--cor-fonte);
}

.agenda-cal-limpar-filtros {
  flex: 0 0 auto;
  align-self: center;
  margin-left: auto;
  padding: 0.4rem 0;
  border: none;
  background: none;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--cor-primaria-forte);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.agenda-cal-limpar-filtros:hover {
  color: var(--cor-primaria);
}

.agenda-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--cor-separador);
}

.agenda-resumo {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.9rem;
}

.resumo-item {
  padding: 0.25rem 0.5rem;
  background: var(--cor-cinza);
  border-radius: 4px;
}

.agenda-follow-lista {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.agenda-follow-card {
  background: var(--cor-bg);
  border: 1px solid var(--cor-separador);
  border-radius: 12px;
  padding: 1rem 1.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.agenda-follow-card:hover {
  border-color: var(--cor-primaria-media);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.agenda-follow-card--clicavel {
  cursor: pointer;
}

.agenda-follow-card--clicavel:focus {
  outline: 2px solid var(--cor-primaria-forte);
  outline-offset: 2px;
}

.agenda-follow-card--clicavel:focus:not(:focus-visible) {
  outline: none;
}

.agenda-follow-card.linha-cancelada {
  opacity: 0.92;
  border-style: dashed;
}

.follow-card-topo {
  flex-wrap: wrap;
  gap: 0.75rem 1rem;
  justify-content: space-between;
  align-items: flex-start;
}

.follow-card-identificacao {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.follow-horario-bloco {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 4.5rem;
}

.follow-hora-principal {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--cor-primaria-forte);
}

.follow-hora-secundaria {
  font-size: 0.75rem;
  color: var(--cor-fonte-fraca);
  margin-top: 0.15rem;
}

.follow-dados-visita {
  min-width: 0;
}

.follow-card-acoes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.follow-card-acoes .chip {
  flex-shrink: 0;
}

.follow-cancelada-msg {
  color: var(--cor-fonte-fraca);
  margin: 0.5rem 0;
  padding: 0.35rem 0.5rem;
  background: var(--cor-cinza);
  border-radius: 6px;
}

.follow-trilha {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: auto;
  padding: 1.35rem 1rem 1.1rem;
  margin-top: 1.1rem;
  border-top: 1px solid var(--cor-separador);
  gap: 0.5rem;
  -webkit-overflow-scrolling: touch;
}

.follow-ponto-wrap {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 4.75rem;
  padding: 0 0.2rem;
}

.follow-ponto {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--cor-separador);
  background: var(--cor-bg);
  transition: border-color 0.2s, background 0.2s, color 0.2s, box-shadow 0.2s;
}

.follow-ponto-icone {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  line-height: 1;
}

.follow-ponto-num {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--cor-fonte-fraca);
}

.follow-ponto.etapa-feita {
  background: var(--cor-primaria);
  border-color: var(--cor-primaria-forte);
  color: var(--cor-bg);
}

.follow-ponto.etapa-feita .follow-ponto-num {
  color: var(--cor-bg);
}

.follow-ponto.etapa-atual {
  border-color: var(--cor-primaria-forte);
  background: var(--cor-primaria-fraca);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06);
}

.follow-ponto.etapa-atual .follow-ponto-num {
  color: var(--cor-primaria-forte);
  font-weight: 800;
}

.follow-ponto.etapa-pendente {
  opacity: 0.88;
}

.follow-ponto.etapa-neutra {
  opacity: 0.45;
  border-style: dashed;
}

.follow-ponto-rotulo {
  margin-top: 0.55rem;
  text-align: center;
  line-height: 1.25;
  max-width: 5rem;
  color: var(--cor-fonte-fraca);
  word-break: break-word;
}

.follow-ponto-wrap:has(.etapa-atual) .follow-ponto-rotulo {
  color: var(--cor-primaria-forte);
  font-weight: 600;
}

.follow-ligacao {
  flex: 1 1 1.25rem;
  min-width: 1rem;
  max-width: 5rem;
  height: 3px;
  margin-top: 1rem;
  border-radius: 2px;
  align-self: flex-start;
}

.follow-ligacao.ligacao-feita {
  background: linear-gradient(90deg, var(--cor-primaria), var(--cor-primaria-forte));
}

.follow-ligacao.ligacao-pendente {
  background: var(--cor-separador);
}

.follow-ligacao.ligacao-neutra {
  background: var(--cor-cinza);
  opacity: 0.5;
}

.agenda-card-nome {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 0.2rem;
}

.agenda-card-empresa {
  font-size: 0.9rem;
  color: var(--cor-fonte);
  margin-bottom: 0.2rem;
}

.agenda-card-setor {
  color: var(--cor-fonte-fraca);
  margin-bottom: 0;
}

.linha-concluida .follow-card-acoes .chip {
  background: var(--cor-primaria-fraca);
  color: var(--cor-sucesso);
}

.linha-em-visita .follow-card-acoes .chip {
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
}

.linha-aguardando .follow-card-acoes .chip {
  background: var(--cor-primaria-fraca);
  color: var(--cor-primaria-forte);
}

.status-cancelada {
  background: var(--cor-cinza2, #e8e8e8);
  color: var(--cor-fonte-fraca);
  text-decoration: line-through;
  text-decoration-color: rgba(0, 0, 0, 0.25);
}

.follow-card-acoes .btn-checklist {
  margin-left: auto;
}

.btn-checklist {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.75rem;
  border: 1px solid var(--cor-primaria);
  border-radius: 24px;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  background: transparent;
  color: var(--cor-primaria);
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  -webkit-appearance: none;
  appearance: none;
  background-image: none !important;
  width: auto;
  max-width: 100%;
}

.btn-checklist:hover {
  background: var(--cor-cinza2, rgba(0, 0, 0, 0.04));
  color: var(--cor-primaria);
}

.status-agendada {
  background: var(--cor-cinza2);
  color: var(--cor-fonte);
}

.mensagem-vazia {
  padding: 2rem;
  color: var(--cor-fonte-fraca);
}

.agenda-loading {
  padding: 1rem;
  color: var(--cor-fonte-fraca);
}

.agenda-loading i {
  margin-right: 0.5rem;
}

.agenda-cal-pesquisa-row {
  display: flex;
  align-items: stretch;
  gap: 0.35rem;
}

.agenda-cal-filtro-input--com-botao {
  flex: 1;
  min-width: 0;
}

.agenda-cal-btn-pesquisar {
  flex-shrink: 0;
  width: 2.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--cor-separador);
  border-radius: 8px;
  background: var(--cor-primaria);
  color: #fff;
  cursor: pointer;
}

.agenda-cal-btn-pesquisar:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(0.75rem, 3vw, 1.5rem);
}

.modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.modal-sheet {
  position: relative;
  z-index: 1;
  width: 100%;
  background: var(--cor-bg);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.modal-sheet--lista-escolha {
  max-width: 26rem;
  max-height: min(85vh, 520px);
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 0.75rem;
}

.modal-titulo-busca {
  margin: 0 0 0.35rem 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.modal-sub-busca {
  margin: 0 0 0.65rem 0;
}

.modal-lista-busca {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  max-height: 55vh;
}

.modal-item-busca {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.5rem;
  border-bottom: 1px solid var(--cor-separador);
  cursor: pointer;
  border-radius: 6px;
}

.modal-item-busca:hover {
  background: var(--cor-primaria-fraca);
}

.modal-item-icone-busca {
  flex-shrink: 0;
  color: var(--cor-primaria-forte);
}

.modal-item-textos-busca {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.modal-item-nome-busca {
  font-weight: 600;
  font-size: 0.95rem;
}

.modal-item-meta-busca {
  font-size: 0.8rem;
  color: var(--cor-fonte-fraca);
}

.modal-item-seta-busca {
  flex-shrink: 0;
  color: var(--cor-primaria-forte);
  font-size: 0.85rem;
}

.modal-fechar-busca {
  margin-top: 0.5rem;
  padding: 0.5rem;
  width: 100%;
  border: none;
  background: transparent;
  color: var(--cor-primaria-forte);
  font-weight: 600;
  cursor: pointer;
}
</style>
